import { apiClient } from '@/services/ApiClient.js'

export default {
  getStockInterests(query) {
    return apiClient
      .get('tarfin-pro-stock-interests', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  create(data) {
    return apiClient
      .post('tarfin-pro-stock-interests', data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  update(data) {
    return apiClient
      .patch('tarfin-pro-stock-interests', data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  findStockInterest(data) {
    return apiClient
      .get('tarfin-pro-stock-interests/find', { params: data })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getHistory(data) {
    return apiClient
      .get('tarfin-pro-stock-interests/history', { params: data })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveFixedStockInterest(data) {
    return apiClient
      .put('tarfin-pro-stock-interests/fixed-stock-interest', data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTypeByCampaignId(data) {
    return apiClient
      .get('tarfin-pro-stock-interests/get-collateral-type-by-tarfin-pro-campaign/', {
        params: data
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMaturityByType(data) {
    return apiClient
      .get('tarfin-pro-stock-interests/get-maturity-by-tarfin-pro-campaign-and-collateral-type/', {
        params: data
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
